import { TourAnchor } from '../anchors';
import type { TourDefinition } from '../types';

/** "New ways to explore Taboo TV" — linked from the What's New announcement. */
export const EXPLORE_TOUR = {
  id: 'explore',
  version: 1,
  slug: 'explore',
  path: '/',
  name: 'Explore Taboo TV',
  summary: 'Search, shorts, the globe, creators and your watchlist.',
  steps: [
    {
      id: 'search',
      anchor: TourAnchor.HEADER_SEARCH,
      title: 'Search everything',
      body: 'Creators, countries, topics — type anything and jump straight in.',
    },
    {
      id: 'shorts',
      anchor: TourAnchor.NAV_SHORTS,
      title: 'Shorts',
      body: 'Quick stories from the road. Swipe up for the next one.',
    },
    {
      id: 'globe',
      anchor: TourAnchor.NAV_GLOBE,
      title: 'The globe',
      body: 'See where every story was filmed and explore by country.',
    },
    {
      id: 'creators',
      anchor: TourAnchor.NAV_CREATORS,
      title: 'Creators',
      body: 'Follow the people behind the stories and never miss a drop.',
    },
    {
      id: 'watchlist',
      anchor: TourAnchor.NAV_WATCHLIST,
      title: 'Your watchlist',
      body: 'Save anything for later — it will be waiting here.',
    },
  ],
} as const satisfies TourDefinition;
